export const CAROUSEL_PAGE_SIZE = 20;
export const EN_LANG_CODE = 'en_US';
export const CAROUSEL_IMAGE_HINT = '700×280';

export function buildCarouselPageParams(pageNo, pageSize = CAROUSEL_PAGE_SIZE) {
  return { pageNo, pageSize };
}

export function emptyCarouselDetail(lang) {
  return {
    lang,
    image: '',
  };
}

export function mergeCarouselDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({
      code: item.lang,
      label: item.lang,
    });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyCarouselDetail(code), _label: label };
  });
}

export function stripCarouselDetails(details) {
  return (details || []).map(({ lang, image }) => ({ lang, image: image || '' }));
}
